<form class="rbac-form" [formGroup]="form" (ngSubmit)="submit()">
  <h5 class="rbac-form__title">{{ title }}</h5>

  <div class="rbac-form__field" *ngFor="let field of fields">
    <label [for]="field.key">
      {{ field.label }}
      <span class="rbac-form__required" *ngIf="field.required &&!isEdit">*</span>
      <span class="rbac-form__required  " *ngIf="field.disabledOnEdit && isEdit">Read Only</span>

    </label>

    <ng-container [ngSwitch]="field.type">
      <input
        *ngSwitchCase="'text'"
        [id]="field.key"
        type="text"
        class="rbac-form__input"
        
        [placeholder]="field.placeholder || ''"
        [formControlName]="field.key" />

      <input
        *ngSwitchCase="'number'"
        [id]="field.key"
        type="number"
        class="rbac-form__input"
        [placeholder]="field.placeholder || ''"
        [formControlName]="field.key" />
        <div *ngSwitchCase="'multiselect'" class="rbac-multiselect">
          <button
            type="button"
            class="rbac-multiselect__trigger"
            (click)="toggleDropdown(field.key)">
            {{ multiSelectLabel(field) }}
            <span class="rbac-multiselect__caret">▾</span>
          </button>

          <div class="rbac-multiselect__panel" *ngIf="openDropdownKey === field.key">
            <label class="rbac-multiselect__option" *ngFor="let opt of field.options">
              <input
                type="checkbox"
                [checked]="isMultiSelected(field.key, opt.value)"
                (change)="toggleMultiSelect(field.key, opt.value)" />
              {{ opt.label }}
            </label>
          </div>
        </div>
      <select
        *ngSwitchCase="'select'"
        [id]="field.key"
        class="rbac-form__input"
        [formControlName]="field.key">
        <option value="" disabled>{{ field.placeholder || 'Select...' }}</option>
        <option *ngFor="let opt of field.options" [value]="opt.value">{{ opt.label }}</option>
      </select>
      <div *ngSwitchCase="'icon-select'" class="rbac-multiselect rbac-icon-select">
        <button
          type="button"
          class="rbac-multiselect__trigger"
          (click)="toggleDropdown(field.key)">
          <ng-container *ngIf="selectedIconOption(field) as sel; else noIconSelected">
            <svg class="rbac-icon-select__preview" width="18" height="18">
              <use [attr.href]="iconHref(field, sel.value)"></use>
            </svg>
            <span>{{ sel.label }}</span>
          </ng-container>
          <ng-template #noIconSelected>
            <span>{{ field.placeholder || 'Select icon...' }}</span>
          </ng-template>
          <span class="rbac-multiselect__caret">▾</span>
        </button>

        <div class="rbac-multiselect__panel rbac-icon-select__panel" *ngIf="openDropdownKey === field.key">
          <input
            type="text"
            class="rbac-icon-select__search"
            placeholder="Search icons..."
            [ngModel]="iconSearchTerm[field.key]"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onIconSearchInput(field.key, $event)"
            (click)="$event.stopPropagation()" />

          <div class="rbac-icon-select__options">
            <button
              type="button"
              class="rbac-icon-select__option"
              *ngFor="let opt of filteredIconOptions(field)"
              [class.rbac-icon-select__option--active]="form.get(field.key)?.value === opt.value"
              (click)="selectIconOption(field.key, opt.value)">
              <svg class="rbac-icon-select__preview" width="18" height="18">
                <use [attr.href]="iconHref(field, opt.value)"></use>
              </svg>
              <span>{{ opt.label }}</span>
            </button>

            <div class="rbac-icon-select__empty" *ngIf="filteredIconOptions(field).length === 0">
              No icons match "{{ iconSearchTerm[field.key] }}"
            </div>
          </div>
        </div>
      </div>
      <button
        *ngSwitchCase="'toggle'"
        type="button"
        class="rbac-toggle"
        [class.rbac-toggle--on]="form.get(field.key)?.value === 'Y'"
        (click)="toggle(field.key)">
        <span class="rbac-toggle__knob"></span>
        <span class="rbac-toggle__label">
          {{ form.get(field.key)?.value === 'Y' ? (field.onLabel || 'Yes') : (field.offLabel || 'No') }}
        </span>
      </button>
    </ng-container>

    <small
      class="rbac-form__error"
      *ngIf="form.get(field.key)?.invalid && form.get(field.key)?.touched">
      {{ field.label }} is required.
    </small>
  </div>

  <div class="rbac-form__actions">
    <button type="button" class="rbac-btn rbac-btn--ghost" (click)="onCancel()">Cancel</button>
    <button type="submit" class="rbac-btn rbac-btn--primary" [disabled]="saving">
      {{ saving ? 'Saving…' : (isEdit ? 'Update' : 'Add') }}
    </button>
  </div>
</form>
